import { render, staticRenderFns } from "./PayWay.vue?vue&type=template&id=1b62b0a2&scoped=true&"
import script from "./PayWay.vue?vue&type=script&lang=js&"
export * from "./PayWay.vue?vue&type=script&lang=js&"
import style0 from "./PayWay.vue?vue&type=style&index=0&id=1b62b0a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b62b0a2",
  null
  
)

export default component.exports